"use client";

import { Button } from "@/components/ui/button";
import { formatJsError } from "@/lib/format-js-error";
import { SentryService } from "@/services/sentry/sentry-service";
import Error from "next/error";
import Image from "next/image";
import { useEffect } from "react";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: ErrorProps) {
  useEffect(() => {
    SentryService.captureException(error);
  }, [error]);

  const resetError = () => {
    reset();
  };

  return (
    <html>
      <body>
        <div className="grid min-h-screen place-items-center gap-3">
          <Image
            src={"/error.svg"}
            width={512}
            height={512}
            alt={"error-graphic"}
          />
          <h2 className="text-center text-2xl font-semibold">
            Something went wrong
          </h2>
          <h3 className="text-center text-destructive">
            {formatJsError(error)}
          </h3>
          <Button
            onClick={resetError}
            gtmEvent={{
              event: "click",
              eventCategory: "error",
              eventLabel: "try-again",
              eventAction: "reset",
            }}
          >
            Try again
          </Button>
        </div>
        {/* This is the default Next.js error component but it doesn't allow omitting the statusCode property yet. */}
        <Error statusCode={undefined as any} />
      </body>
    </html>
  );
}
